import React from 'react'
import './Footer.css';

import logoMinistere from '../assets/ministere.png';
import logoAgenceDuSport from '../assets/agence_du_sport.png';
import logoCreditMutuel from '../assets/credit_mutuel.png';
import logoTibhar from '../assets/tibhar.png';
import leapmotor from '../assets/leapmotor.png';
import logoCornilleau from '../assets/cornilleau.png';
import logoDonic from '../assets/donic.png';
import logoGerflor from '../assets/gerflor.png';
import logoLequipe from '../assets/lequipe.png';

import { useLocation, NavLink } from 'react-router-dom';

function Footer() {
    const location = useLocation();
    const classeLocation =  location.pathname.split('/')[1];

    const openWindow = (link) => {
        window.open(link, '_blank');
    }

    return (
        <div className="footer_component">

            <div className="footer_flag">
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div className="footer_partenaires">
                <div className="footer_partenaires_images">
                    <span className={'footer_span_partenaires ' + classeLocation}>Partenaires officiels</span>
                    <div className="footer_logos_row">
                        <img className="footer_logo_white_bg" src={logoMinistere} alt="Ministère des Sports" onClick={()=>openWindow('https://www.jeunes.gouv.fr/la-ministre-des-sports-de-la-jeunesse-et-de-la-vie-associative-2437')} />
                        <img src={logoAgenceDuSport} alt="Agence du Sport" onClick={()=>openWindow('https://www.agencedusport.fr/')} />
                        <img src={logoCreditMutuel} alt="Crédit Mutuel" onClick={()=>openWindow('https://www.creditmutuel.fr/home/index.html')} />
                        <img src={logoTibhar} alt="Tibhar" onClick={()=>openWindow('https://tibhar.info/home/')} />
                        <img src={leapmotor} alt="Leapmotor" onClick={()=>openWindow('https://www.leapmotor.net/fr')} />
                        <img src={logoCornilleau} alt="Cornilleau" onClick={()=>openWindow('https://fr.cornilleau.com/')} />
                        <img src={logoDonic} alt="Donic" onClick={()=>openWindow('https://www.donic.com/fr/')} />
                        <img src={logoGerflor} alt="Gerflor" onClick={()=>openWindow('https://www.gerflor.fr/')} />
                        <img src={logoLequipe} alt="L'Équipe" onClick={()=>openWindow('https://www.lequipe.fr/')} />
                    </div>
                </div>
            </div>
            <section className="footer_links">
                <div className="footer_links_wrapper">
                    <ul className="footer_links_nav">
                        <li>
                            <a href="https://www.fftt.com/site/articles/mentions-legales" target="_blank" rel="noreferrer">Mentions légales</a>
                        </li>
                        <li>
                            <a href="https://www.fftt.com/site/contactez-nous" target="_blank" rel="noreferrer">Contact</a>
                        </li>
                        <li>
                            <NavLink to="/docs">Documentation</NavLink>
                        </li>
                    </ul>
                    <ul className="footer_links_mentions">
                        <li>Copyright FFTT PRO 2026</li>
                    </ul>
                </div>
            </section>
        </div>
    );
}

export default Footer;
